//ReadMSMEYB.js
import React, { useCallback, useState, useEffect, useHistory } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import Tooltip from '../../components/utils/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlay,
  faPlayCircle,
  faStop,
  faVolumeMute,
  faVolumeUp,
  faSpinner,
  faMusic,
  faCommenting,
  faEdit,
  faLink,
  faGears,
  faComment,
  faComments,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import Speech from "speak-tts";
import "../learning/styles/ReadBook.css";
import SpeechInputComponent from '../../components/SpeechInputComponent';
import AILightComponent from '../../components/AILightComponent';
// import HandwritingToText from './HandwritingToText';
// import MathOCR from './MathOCR';
// ✅ Correct path matching your public folder structure
const backgroundMusic = process.env.PUBLIC_URL + '/assets/sounds/AnimalMovieRingtone.mp3';

const ReadMSMEYB = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  // Retrieve initial state from location or fallback to an empty object
  const [initialState, setInitialState] = useState(() => location.state || {});

  // Ensure userId is updated correctly
  const [userId, setUserId] = useState(() => authState.user._id);

  // Initialize state for savedBookMasterIdFromState
  const [savedBookMasterIdFromState, setSavedBookMasterIdFromState] = useState(() => initialState.bookMasterId || '');

  // Initialize state for bookMasterId
  const [bookMasterId, setBookMasterId] = useState(() => initialState.bookMasterId || savedBookMasterIdFromState);

  // Fallback to default values if state properties are undefined
  const bookCollectionName = initialState.bookCollectionName || "defaultCollectionName";
  const pageNumber = initialState.lastPageRead || 1;
  const bookPages = initialState.bookPages || [];
  const isChildren = initialState.isChildren || 0;

  useEffect(() => {
    // Any logic that needs to run on component mount or when dependencies change
    // Avoid updating state here that would cause a dependency loop

    // console.log("userId:", userId);
    // console.log("bookMasterId:", bookMasterId);

  }, [userId, bookMasterId]); // Only run when userId or bookMasterId changes

  
  const [numberOfPages, SetNumberOfPages] = useState(bookPages);
  const [pageContent, setPageContent] = useState("");
  const [splText, setSplText] = useState("");
  const [bookTitle, setBookTitle] = useState("");
  const [currentPageNumber, setCurrentPageNumber] = useState(pageNumber);
  const [hasSpeech, setHasSpeech] = useState(0);
  const [hasMusic, setHasMusic] = useState(0);
  const [hasVideo, setHasVideo] = useState(0);
  const [videoUrl, setVideoUrl] = useState(0);
  const [isBase64Audio, setIsBase64Audio] = useState(0);
  const [base64Audio, setBase64Audio] = useState(false);

  const [isPageImage, setIsPageImage] = useState(false);
  const [pageImageURL, setPageImageURL] = useState('');
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);

  const [readFromSplText, setReadFromSplText] = useState(0);
  const [musicAudio] = useState(new Audio(backgroundMusic));
  const [pageCount, setPageCount] = useState(bookPages);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const [dateRead, setDateRead] = useState(new Date());
  const [pageLoadTime, setPageLoadTime] = useState(null);
  const [readTimeInMiliseconds, setReadTimeInMiliseconds] = useState(0);
  const [readingRemarks, setReadingRemarks] = useState("");
  const [isLogSaved, setIsLogSaved] = useState(true);
  const [isInteracted, setIsInteracted] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [notesType, setNotesType] = useState("");
  const [userCommentTitle, setUserCommentTitle] = useState("");
  const [userCommentDetails, setUserCommentDetails] = useState("");
  const [selectedLangCode, setSelectedLangCode] = useState('en-US');
  const [isImportantChecked, setIsImportantChecked] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const [listLink, setListLink] = useState(false);
  const [addNewLink, setAddNewLink] = useState(false);
  const [closeLink, setCloseLink] = useState(false);

  const [linkName, setLinkName] = useState("");
  const [linkPageName, setLinkPageName] = useState("");
  const [linkTitle, setLinkTitle] = useState("");
  const [linkAddress, setLinkAddress] = useState("");

  const [isVideoChecked, setIsVideoChecked] = useState(true);
  const [linkDetails, setLinkDetails] = useState("");
  const [bookLinkSaved, setBookLinkSaved] = useState(false);
  const [bookLinkSavedMsg, setBookLinkSavedMsg] = useState(false);
  const [savedBookLinkMsg, setSavedBookLinkMsg] = useState('');
  const [bookLinkClicked, setBookLinkClicked] = useState(false);
  const [bookLinkCloseClicked, setBookLinkCloseClicked] = useState(false);
  const [bookLinkToBeDisabled, setBookLinkToBeDisabled] = useState(false);
  const [saveBookLinkToBeDisabled, setSaveBookLinkToBeDisabled] = useState(false);
  const [saveBookLinkClicked, setSaveBookLinkClicked] = useState(false);

  const [elapsedTime, setElapsedTime] = useState(0);
  const [error, setError] = useState(false);
  const [commentListFetched, setCommentListFetched] = useState(false)
  const [commentData, setCommentData] = useState([]);
  const [postCommentClicked, setPostCommentClicked] = useState(false);
  const [postedComment, setPostedComment] = useState(false);
  const [errors, setErrors] = useState();
  const [userComment, setUserComment] = useState('');
  const [postedCommentMsg, setPostedCommentMsg] = useState('');
  const [isVisibleToAllChecked, setIsVisibleToAllChecked] = useState(false);
  const [isConversationalNotes, setIsCoversationalNotes] = useState(false);

  const [postToBeDisabled, setPostToBeDisabled]=useState(false);
  const [readCommentClicked,setReadCommentClicked]=useState(false);
  const [postCloseClicked, setPostCloseClicked] = useState(false);
  const [readCommentCloseClicked, setReadCommentCloseClicked] = useState(false);
  const [settingsClicked, setSettingsClicked] = useState(false);
  const [settingsClosed, setSettingsClosed] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en-US");
  const [rate, setRate] = useState(1.0);
  const [pitch, setPitch] = useState(1.0);
  const [volume, setVolume] = useState(1.0);
  const [isContinuousAutoPageReadChecked, setIsContinuousAutoPageReadChecked] = useState(false);
  const [fromPageNumber, setFromPageNumber] = useState(1);
  const [toPageNumber, setToPageNumber] = useState(1);
  const [selectedNeuralVoice, setSelectedNeuralVoice] = useState('');
  const [selectedStandardVoice, setSelectedStandardVoice] = useState('');
  const [selectedExpressiveVoice, setSelectedExpressiveVoice] = useState('');
  const [selectedAccent, setSelectedAccent] = useState('');
  const [selectedCharacterVoice, setSelectedCharacterVoice] = useState('');
  const [isVoiceNotesEnabled, setIsVoiceNotesEnabled] = useState('');
  const [isSmartSpeakerEnabled, setIsSmartSpeakerEnabled] = useState('');
  const [isHandWrittenTextInputEnabled, setIsHandWrittenTextInputEnabled] = useState('');
  const [isHandWrittenFormulaInputEnabled, setIsHandWrittenFormulaInputEnabled] = useState('');
  const [isHandwritingVisible, setIsHandwritingVisible] = useState(false);
  const [isMathOCRVisible, setIsMathOCRVisible] = useState(false);

  const handleRateChange = (e) => setRate(parseFloat(e.target.value));
  const handleVolumeChange = (e) => setVolume(parseFloat(e.target.value));
  const handlePitchChange = (e) => setPitch(parseFloat(e.target.value));

  const [isCheckedAISupport, setIsCheckedAISupport] = useState(false);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);

  const handleOpenHandwriting = () => {
    setIsHandwritingVisible(true);
  };

  const handleCloseHandwriting = () => {
    setIsHandwritingVisible(false);
  };

  const handleOpenMathOCR = () => {
    setIsHandwritingVisible(true);
  };

  const handleCloseMathOCR = () => {
    setIsHandwritingVisible(false);
  };

  const languageOptions = [
    { code: "en-US", name: "English (United States)" },
    { code: "en-GB", name: "English (United Kingdom)" },
    { code: "en-AU", name: "English (Australia)" },
    { code: "en-CA", name: "English (Canada)" },
    { code: "en-IN", name: "English (India)" },
    { code: "fr-FR", name: "French (France)" },
    { code: "fr-CA", name: "French (Canada)" },
    { code: "es-ES", name: "Spanish (Spain)" },
    { code: "es-MX", name: "Spanish (Mexico)" },
    { code: "de-DE", name: "German (Germany)" },
    { code: "it-IT", name: "Italian (Italy)" },
    { code: "pt-BR", name: "Portuguese (Brazil)" },
    { code: "pt-PT", name: "Portuguese (Portugal)" },
    { code: "ru-RU", name: "Russian (Russia)" },
    { code: "ja-JP", name: "Japanese (Japan)" },
    { code: "zh-CN", name: "Chinese (Simplified, China)" },
    { code: "zh-TW", name: "Chinese (Traditional, Taiwan)" },
    { code: "ko-KR", name: "Korean (South Korea)" },
    { code: "nl-NL", name: "Dutch (Netherlands)" },
    { code: "sv-SE", name: "Swedish (Sweden)" },
    { code: "no-NO", name: "Norwegian (Norway)" },
    { code: "da-DK", name: "Danish (Denmark)" },
    { code: "fi-FI", name: "Finnish (Finland)" },
    { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
    { code: "hi-IN", name: "Hindi (India)" },
    { code: "bn-BD", name: "Bengali (Bangladesh)" },
    { code: "ta-IN", name: "Tamil (India)" },
    { code: "te-IN", name: "Telugu (India)" },
    { code: "ur-PK", name: "Urdu (Pakistan)" },
    { code: "tr-TR", name: "Turkish (Turkey)" },
    { code: "el-GR", name: "Greek (Greece)" },
  ];

// SpeechSynthesisVoice
// 0: {voiceURI: 'Microsoft David - English (United States)', name: 'Microsoft David - English (United States)', lang: 'en-US', localService: true, default: true}
// 1: {voiceURI: 'Microsoft Ravi - English (India)', name: 'Microsoft Ravi - English (India)', lang: 'en-IN', localService: true, default: false}
// 2: {voiceURI: 'Microsoft Heera - English (India)', name: 'Microsoft Heera - English (India)', lang: 'en-IN', localService: true, default: false}
// 3: {voiceURI: 'Microsoft Mark - English (United States)', name: 'Microsoft Mark - English (United States)', lang: 'en-US', localService: true, default: false}
// 4: {voiceURI: 'Microsoft Zira - English (United States)', name: 'Microsoft Zira - English (United States)', lang: 'en-US', localService: true, default: false}
// 5: {voiceURI: 'Microsoft Hemant - Hindi (India)', name: 'Microsoft Hemant - Hindi (India)', lang: 'hi-IN', localService: true, default: false}
// 6: {voiceURI: 'Microsoft Kalpana - Hindi (India)', name: 'Microsoft Kalpana - Hindi (India)', lang: 'hi-IN', localService: true, default: false}
// 7: {voiceURI: 'Google Deutsch', name: 'Google Deutsch', lang: 'de-DE', localService: false, default: false}
// 8: {voiceURI: 'Google US English', name: 'Google US English', lang: 'en-US', localService: false, default: false}
// 9: {voiceURI: 'Google UK English Female', name: 'Google UK English Female', lang: 'en-GB', localService: false, default: false}
// 10: {voiceURI: 'Google UK English Male', name: 'Google UK English Male', lang: 'en-GB', localService: false, default: false}
// 11: {voiceURI: 'Google español', name: 'Google español', lang: 'es-ES', localService: false, default: false}
// 12: {voiceURI: 'Google español de Estados Unidos', name: 'Google español de Estados Unidos', lang: 'es-US', localService: false, default: false}
// 13: {voiceURI: 'Google français', name: 'Google français', lang: 'fr-FR', localService: false, default: false}
// 14: {voiceURI: 'Google हिन्दी', name: 'Google हिन्दी', lang: 'hi-IN', localService: false, default: false}
// 15: {voiceURI: 'Google Bahasa Indonesia', name: 'Google Bahasa Indonesia', lang: 'id-ID', localService: false, default: false}
// 16: {voiceURI: 'Google italiano', name: 'Google italiano', lang: 'it-IT', localService: false, default: false}
// 17: {voiceURI: 'Google 日本語', name: 'Google 日本語', lang: 'ja-JP', localService: false, default: false}
// 18: {voiceURI: 'Google 한국의', name: 'Google 한국의', lang: 'ko-KR', localService: false, default: false}
// 19: {voiceURI: 'Google Nederlands', name: 'Google Nederlands', lang: 'nl-NL', localService: false, default: false}
// 20: {voiceURI: 'Google polski', name: 'Google polski', lang: 'pl-PL', localService: false, default: false}
// 21: {voiceURI: 'Google português do Brasil', name: 'Google português do Brasil', lang: 'pt-BR', localService: false, default: false}
// 22: {voiceURI: 'Google русский', name: 'Google русский', lang: 'ru-RU', localService: false, default: false}
// 23: {voiceURI: 'Google 普通话（中国大陆）', name: 'Google 普通话（中国大陆）', lang: 'zh-CN', localService: false, default: false}
// 24: {voiceURI: 'Google 粤語（香港）', name: 'Google 粤語（香港）', lang: 'zh-HK', localService: false, default: false}
// 25: {voiceURI: 'Google 國語（臺灣）', name: 'Google 國語（臺灣）', lang: 'zh-TW', localService: false, default: false}

  const [readSettings, setReadSettings] = useState({
    practiceApproach: '',
    timer: '',
    screenType: '',
    practiceMedium: '',
    baseLanguage: 'en-US',
    pitch: 1.0,
    speed: 1.0,
    volume: 1.0,
    aiSpeechToText: '',
    cloudStorage: '',
    personalCloud: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReadSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value
    }));
  };

  const handleLanguageChange = (e) => {
    const selectedCode = e.target.value;
    setSelectedLanguage(selectedCode);
  };

  useEffect(() => {
    const startTime = new Date();
    setPageLoadTime(startTime);
  }, []); 


  useEffect(() => {
    setPageLoadTime(new Date());
  }, []);

  const resetElapsedTime = () => {
    setElapsedTime(0);
  };
  useEffect(() => {
    const timer = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);


  // OpenBookPage
  const fetchOpenBookPage = useCallback(() => {
    if(bookMasterId === "nobookmasterid") {
      return;
    }
    const config = {
      url: "/readcafebook/my",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        userId,
        bookMasterId,
        bookCollectionName,
        currentPageNumber,
        readerCode: authState.user.think5whyscode,
        readerName: authState.user.name
      },
    };

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response && response.pageContent) {
          // console.log("Page Content from User Open Book staus yes: ",response.status);
          // console.log("Page Content from User Open Book 1: ",response.pageContent);

          setPageContent(response.pageContent.pageContent);
          setSplText(response.pageContent.splText);
          setBookTitle(response.pageContent.bookTitle);
          setHasSpeech(0);
          setHasMusic(0);
          setHasVideo(response.pageContent.hasVideo);
          setVideoUrl(response.pageContent.videoURL);
          setIsBase64Audio(false);
          setBase64Audio('');
          setReadFromSplText(response.pageContent.readFromSplText);
          setIsPageImage(false);
          setPageImageURL('');
          setError(null);
        } else {
          const htmlString = `
            <div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-size: 24px; text-align: center; margin: auto; color: #0000ff;">
              You have not set up this page yet. Create your own page in the My Own Pages section using text or simple formatted HTML code within a div tag!
            </div>
          `;
          setPageContent(htmlString);
          setSplText('');
          setBookTitle(bookTitle);
          setHasSpeech(0);
          setHasMusic(0);
          setHasVideo(0);
          setVideoUrl('');
          setIsBase64Audio(false);
          setBase64Audio('');
          setReadFromSplText(0);
          setIsPageImage(false);
          setPageImageURL('');
          setError(null);
          // console.log("User Own Open Text Page data not found in response");
        }
        resetElapsedTime();
        setPageLoadTime(new Date());
      })
      .catch((error) => {
        console.error("Error fetching book page:", error);
      });
  }, [
    authState.token,
    bookMasterId,
    bookCollectionName,
    currentPageNumber,
    fetchData,
  ]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchOpenBookPage();
  }, [
    authState.isLoggedIn,
    fetchOpenBookPage,
    location.state.bookMasterId,
    location.state.bookCollectionName,
    location.state.lastPageRead,
  ]);

  // Save Read Log
  const saveReadLog = async (remarks, elapsedTime, whichButton) => {
    const localDateString = new Date(dateRead - dateRead.getTimezoneOffset() * 60000).toISOString();

    try {
      const readingRemarks = isChildren === 1 ? splText : remarks;
      const response = await fetch("/api/myreadinglog", {
        method: "POST",
        headers: {
          Authorization: authState.token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          bookId: bookMasterId,
          userId: userId,
          dateRead: localDateString,
          pageNumber: currentPageNumber,
          readTimeInMiliseconds: elapsedTime,
          readingRemarks: readingRemarks,
          isActive: 1,
          isDeleted: 0,
          coReaderId: userId,
          readerCode: authState.user.think5whyscode,
          readerName: authState.user.name,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to update app like");
      }

      const data = await response.json();
      setSuccessMessage(true);
      setReadTimeInMiliseconds(0);
      setPageLoadTime(new Date());
    } catch (error) {
      console.error("Error while saving read log:", error);
    }
  };

  const saveReadLogIfNeeded = () => {
    if (isInteracted && !isLogSaved) {
      setCurrentPageNumber(currentPageNumber);
      let currentTime = new Date();
      const elapsedTime = currentTime - pageLoadTime;
      setReadTimeInMiliseconds(elapsedTime);
      setReadingRemarks("Swipe");
      saveReadLog(currentPageNumber, elapsedTime, "Selected Page");
      currentTime = new Date();
      setPageLoadTime(currentTime);
      setIsLogSaved(true);
    }
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handlePageChange = (e) => {
    const selectedPage = parseInt(e.target.value);
    setCurrentPageNumber(selectedPage);
    const currentPageNumber = selectedPage;
    setReadingRemarks("Select Page Clicked");

    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);

    saveReadLog(currentPageNumber, elapsedTime, "Selected Page");
    currentTime = new Date();
    setPageLoadTime(currentTime);
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handleNextPage = () => {
    setReadingRemarks("Next button clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);

    saveReadLog(currentPageNumber, elapsedTime, "Next Button");
    currentTime = new Date();
    setPageLoadTime(currentTime);

    if (currentPageNumber < pageCount) {
      speech.cancel();
      setIsSpeaking(false);
      setCurrentPageNumber(currentPageNumber + 1);
    }
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handlePrevPage = () => {
    setReadingRemarks("Prev button clicked");
    let currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);
    saveReadLog(currentPageNumber, elapsedTime, "Prev Button");
    currentTime = new Date();
    setPageLoadTime(currentTime);
    if (currentPageNumber > 1) {
      speech.cancel();
      setIsSpeaking(false);
      setCurrentPageNumber(currentPageNumber - 1);
    }
  };

  useEffect(() => {
    setReadTimeInMiliseconds();
    setReadingRemarks();
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const handleSwipe = () => {
    setIsInteracted(true);
    setReadingRemarks("Swiped");
    saveReadLogIfNeeded();
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => {
      handleSwipe();
      handleNextPage();
    },
    onSwipedRight: () => {
      handleSwipe();
      handlePrevPage();
    },
  });

  const handleClose = () => {
    setReadingRemarks("Close button clicked");
    const currentTime = new Date();
    const elapsedTime = currentTime - pageLoadTime;
    setReadTimeInMiliseconds(elapsedTime);
    const remarks = "Closed";
    saveReadLog(currentPageNumber, elapsedTime, "Close Button")
      .then(() => {
        window.location.href = "/cafe-home";
      })
      .catch((error) => {
        console.error("Error saving log:", error);
      });
  };

  useEffect(() => {
    setReadTimeInMiliseconds(0);
    setPageLoadTime(new Date());
  }, []);

  useEffect(() => {
    //
  }, [readTimeInMiliseconds]);

  const speech = new Speech();
  const toggleSpeech = () => {
    const textToSpeak = readFromSplText === 1 ? splText : pageContent;
    // console.log("999: ", textToSpeak, selectedLangCode);
  
    if (isSpeaking) {
      speech.cancel();
      setIsSpeaking(false);
      clearInterval(emojiInterval); 
      setShowEmoji(false); 
    } else {
      setIsSpeaking(true);
  
      const voices = window.speechSynthesis.getVoices();
      const selectedVoice = voices.find(
        (voice) => voice.lang === "en-US" && voice.name === "Google US English"
      );
  
      if (selectedVoice) {
        speech.voice = selectedVoice;
      } else {
        const fallbackVoice = voices.find((voice) => voice.lang === "en-US");
        if (fallbackVoice) {
          speech.voice = fallbackVoice;
        }
      }
  
      // Set other speech parameters
      speech.setRate(1.0); // Normal speaking rate
      speech.setPitch(2.0); // Adjust pitch to your liking
      speech.setVolume(1.0); // Maximum volume
      speech.setLanguage(selectedLangCode); // Ensure the language is still set
  
      // Start speaking the selected text
      speech.speak({ text: textToSpeak });
  
      // Show emoji overlay and start interval
      setShowEmoji(true);
      const interval = setInterval(() => {
        setCurrentEmoji((prev) => (prev === "😮" ? "😐" : "😮"));
      }, 250);
      setEmojiInterval(interval);
    }
  };

  useEffect(() => {
    return () => {
      if (isSpeaking) {
        speech.cancel();
        setIsSpeaking(false);
      }
    };
  }, [isSpeaking]);

  const [currentEmoji, setCurrentEmoji] = useState("😐");
  const [showEmoji, setShowEmoji] = useState(false);
  const [emojiInterval, setEmojiInterval] = useState(null);

  useEffect(() => {
    return () => {
      if (emojiInterval) clearInterval(emojiInterval);
    };
  }, [emojiInterval]);


  const [isNotesSpeaking, setIsNotesSpeaking] = useState(false);
  const toggleSpeechNotes = (mynotestext) => {
    // console.log("my notes text ",mynotestext);
    if (isNotesSpeaking) {
      speech.cancel();
      setIsNotesSpeaking(false);
    } else {
      setIsNotesSpeaking(true);
      speech.setRate(1.0);
      speech.setPitch(2.0);
      speech.setVolume(1.0);
      speech.setLanguage(selectedLangCode);
      speech.speak({ text: mynotestext });
    }
  };

  useEffect(() => {
    return () => {
      if (isNotesSpeaking) {
        speech.cancel();
        setIsNotesSpeaking(false);
      }
    };
  }, [isNotesSpeaking]);


  const toggleMusic = () => {
    if (isListening) {
      musicAudio.pause();
    } else {
      musicAudio.play();
    }

    setIsListening(!isListening);
  };

  musicAudio.addEventListener("ended", () => {
    if (isListening) {
      musicAudio.currentTime = 0;
      musicAudio.play();
    }
  });

  const watchVideo = () => {
    // console.log("Video URL Check ",hasVideo, videoUrl);
    if (videoUrl) {
      window.open(videoUrl, "_blank");
    }
  };

  const accessSite = (siteUrl) => {
    if (siteUrl) {
      const formattedUrl = siteUrl.startsWith("http://") || siteUrl.startsWith("https://")
        ? siteUrl
        : `http://${siteUrl}`;
      window.open(formattedUrl, "_blank");
    } else {
      console.error("URL is not provided.");
    }
  };
  

  const listenVoice = () => {
    if (base64Audio) {
      const audio = new Audio(`data:audio/mpeg;base64,${base64Audio}`);
      audio.play();
    }
  };

  const handleImportantCheckboxChange = (event) => {
    setIsImportantChecked(event.target.checked);
  };
  
  const handleVisibleToAllCheckboxChange = (event) => {
    setIsVisibleToAllChecked(event.target.checked);
  };

  const handleConversationalNotesCheckboxChange = (event) => {
    setIsCoversationalNotes(event.target.checked);
  };

  const handleShowMicrophoneAlertCheckboxChange = (event) => {
    setShowMicrophoneAlert(event.target.checked);
  };

  const postComment = () => {
    setNotesType('');
    setUserCommentTitle('');
    setUserCommentDetails('');
    setIsImportantChecked(false);
    setIsVisibleToAllChecked(false);
    setErrors('');
    setPostedCommentMsg('');    
    setPostCommentClicked(true);
    setPostCloseClicked(false);
    setPostToBeDisabled(false);
    setViewComment(false);
    setPostedComment(false);
  };

  const handlePostComment = (commentTitle, commentDetails, isImportant, visibleToAll, pageNumber, bookTitle) => {
    setPostCommentClicked(true);
    setPostToBeDisabled(false);

    // console.log('inside handlePostComment', pageNumber );
    if(commentTitle=='')
      {
        setErrors("Comment title must not be blank");
        return;
      }
      if(commentDetails=='')
        {
          setErrors("Comment/details must not be blank");
          return;
        }
    postReadComment(commentTitle, commentDetails, isImportant, visibleToAll, pageNumber, bookTitle);
  };


//Read Post Comments 
const postReadComment = useCallback((commentTitle, commentDetails, isImportant, visibleToAll, pageNumber, bookTitle) => {
    const config = {
      url: "/myreadingnotes",
      method: "post",
      headers: { Authorization: authState.token },
      data: { 
        userId: userId,
        bookId: bookMasterId, 
        bookTitle: bookTitle,
        pageNumber: pageNumber,
        isImportant: isImportant,
        notesType: 'Quick Note',
        notesTitle: commentTitle,
        notesText: commentDetails, 
        notesBy: authState.user.name, 
        notesByCode: authState.user.think5whyscode,
        visibleToAll: visibleToAll,
        teamCode: '',
        notesPictureData: '',
        isActive: true,
        isDeleted: false,
        dateCreated: new Date(),
        notesRemarks: '', 
        creatorId:authState.user._id
      }
    };
    // console.log("BookRead Post Comments config to server: ", config);
  
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("BookRead comments data posting Response:", response);
        if (response && response.status) {
          setPostedComment(true);
          setPostedCommentMsg("Comment Posted");
          setError('');
        } else {
          console.error("BookRead comments data posting error");
          setPostedCommentMsg("Error in Posting Your Comment. Please Retry.");
        }
      })
      .catch(error => {
        console.error("Error in Posting Your Comment:", error);
      });
  }, [authState.token, setPostedComment, setPostedCommentMsg]);


  const readComment = () => {
    setReadCommentClicked(true);
    // fetchReadCommentByPageNumber();
  };

  //Read Comments List
  const fetchReadCommentByPageNumber = useCallback(() => {
    const config = {
      url: "/myreadingnotes/notesbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: bookMasterId, 
        userId: userId, 
        pageNumber: currentPageNumber
      }
    };
    // console.log("Read Comments config to server: ", config);
    
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Read Comments Response:", response);
        if (response && response.status) {
          setCommentData(response.notes);
          // console.log("setCommentData ", response.notes); // Log response.notes
        } else {
          console.error("Read Comments data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching Read Comments data:", error);
      });
  }, [authState.token, fetchData, bookMasterId, userId, currentPageNumber]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchReadCommentByPageNumber();
  }, [authState.isLoggedIn, fetchReadCommentByPageNumber]);

  const sortedCommentData = [...commentData ].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

  const handlePostClose = () => {
    setPostCloseClicked(true);
    setPostCommentClicked(true);
    setPostToBeDisabled(true);
    setAddNewLink(false);
    setReadCommentClicked(false);
    setViewComment(false);
    setPostedComment(false);
  };

  const [viewComment, setViewComment] = useState(false);
  const handleViewComment = () => {
    setViewComment(true);
    setPostCommentClicked(false);
    fetchReadCommentByPageNumber();
  }

  const handleReadCommentClose = () => {
    setReadCommentClicked(false);
    setReadCommentCloseClicked(true);
  };

  const handleListLinkButtonClick = () => {
    setListLink(true);
    setAddNewLink(false);
    fetchListLinkByPageNumber();
  };

  const handleAddNewLinkButtonClick = () => {
    setAddNewLink(true);
    setListLink(false);
  };

  const handleCloseLinkButtonClick = () => {
    setBookLinkClicked(false);
  };

  const handleListLinkCloseButtonClick = () => {
    setListLink(false);
  };
  
  const bookLinks = () => {
    setErrors('');
    setSavedBookLinkMsg('');    
    setBookLinkClicked(true);
    setBookLinkCloseClicked(false);
    setBookLinkToBeDisabled(false);
    setSaveBookLinkClicked(false);
    setSaveBookLinkToBeDisabled(false);
    setAddNewLink(false);
    setListLink(false);
  };



  const settings = () => {
    setSettingsClicked(true);
  };

  const handleSettingsClose = () => {
    setSettingsClicked(false);
    // setSettingsClosed(true);
  };


  const [listLinkData, setListLinkData] = useState([]);
  //Get List Link
  const fetchListLinkByPageNumber = useCallback(() => {
    const config = {
      url: "/myreadingnotesurls/linksbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: bookMasterId, 
        userId: userId, 
        pageNumber: currentPageNumber
      }
    };
    // console.log("List Link config to server: ", config);
    
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("List Link Response:", response);
        if (response && response.status) {
          setListLinkData(response.urls);
          // console.log("setListLinkData ", response.urls); // Log response.notes
        } else {
          console.error("List Link data not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching List Link data:", error);
      });
  }, [authState.token, fetchData, bookMasterId, userId, currentPageNumber]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchListLinkByPageNumber();
  }, [authState.isLoggedIn, fetchListLinkByPageNumber]);

  const sortedListLinkData = [...listLinkData ].sort((a, b) => b.linkName - a.linkName);

  const handleIsVideoCheckboxChange = (event) => {
    setIsVideoChecked(event.target.checked);
  };

                     
  const handleSaveBookLink = (linkName, linkPageName, linkTitle, linkAddress, isVideoChecked, linkDetails, linkPageNumber) => {
    setSaveBookLinkClicked(true);
    setSaveBookLinkToBeDisabled(false);

    // console.log('inside hahandleSaveBookLink', pageNumber );
    if(linkName=='')
      {
        setErrors("Link name required!");
        return;
      }
      if(linkPageName=='')
        {
          setErrors("Page/Channel name required!");
          return;
      }
      if(linkAddress=='')
        {
          setErrors("Link URL/address is required!");
          return;
        }
      if(linkTitle=='')
        {
          setErrors("Title required!");
          return;
        }
    saveBookLink(linkName, linkPageName, linkTitle, linkAddress, isVideoChecked, linkDetails, linkPageNumber);
  };

const saveBookLink = useCallback((linkName, linkPageName, linkTitle, linkAddress, isVideoChecked, linkDetails, linkPageNumber) => {
    const config = {
      url: "/myreadingnotesurls",
      method: "post",
      headers: { Authorization: authState.token },
      data: { 
        userId: userId,
        bookId: bookMasterId, 
        bookTitle: bookTitle,
        pageNumber: linkPageNumber,
        linkName: linkName,
        linkPageName: linkPageName, 
        linkTitle: linkTitle, 
        linkAddress: linkAddress,
        isVideoChecked: isVideoChecked,
        linkDetails: linkDetails,
        isActive: true,
        isDeleted: false,
        dateCreated: new Date(), 
        creatorId:authState.user._id
      }
    };
    // console.log("BookRead Book Link config to server: ", config);
  
    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("BookRead Book Link  data posting Response:", response);
        if (response && response.status) {
          setBookLinkSaved(true);
          setBookLinkSavedMsg("BookLink Saved.");
          setAddNewLink(false);
          setListLink(false);
          setLinkAddress('');
          setIsVideoChecked(false);
          setLinkTitle('');
        } else {
          console.error("Booklink data posting error");
          setBookLinkSavedMsg("Error in Posting Your BookLink. Please Retry.");
        }
      })
      .catch(error => {
        console.error("Error in Posting Your Booklink:", error);
      });
  }, [authState.token, setBookLinkSaved, setBookLinkSavedMsg]);


  const formatDateTime = (date) => {
    const options = {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  const handleSaveSettings = () => {
    // console.log('inside handleSaveSettings' );
    
    const saveSettings = '';
    setSettingsClicked(false);

  };

  const handleContinuousAutoPageReadChange = (event) => {
    setIsContinuousAutoPageReadChecked(event.target.checked);
    if (!event.target.checked) {
      setFromPageNumber(1);
      setToPageNumber(1);
    }
  };

  const handleFromPageNumberChange = (event) => {
    const value = Math.min(Math.max(1, parseInt(event.target.value)), numberOfPages);
    setFromPageNumber(value);
    if (value > toPageNumber) {
      setToPageNumber(Math.min(value + 4, numberOfPages));
    }
  };
  
  const handleToPageNumberChange = (event) => {
    const value = Math.min(Math.max(fromPageNumber, parseInt(event.target.value)), fromPageNumber + 4, numberOfPages);
    setToPageNumber(value);
  };

  const [isListenNotesClicked, setIsListenNotesClicked] = useState(false);
  
  const listenNotesClicked = (mynotestext) => {
    setIsListenNotesClicked(true);
    speech.cancel();
    toggleSpeechNotes(mynotestext);
  }

  const [isDeleteCommentClicked, setIsDeleteCommentClicked] = useState(false);
  
  const deleteCommentClicked = () => {
    setIsDeleteCommentClicked(true);
  }
  
  const noDeleteCommentClicked = () => {
    setIsDeleteCommentClicked(false);
  }

  const handleDeleteComment = (id) => {
    const config = {
      url: `/myreadingnotes/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => {
      setCommentData(commentData.filter(commentData => commentData._id !== id));
      setIsDeleteCommentClicked(false);
    }).catch(error => {
      console.error('Failed to delete the record:', error);
    });
  }

  const [isDeleteLinkClicked, setIsDeleteLinkClicked] = useState(false);
  
  const deleteLinkClicked = () => {
    setIsDeleteLinkClicked(true);
  }
  
  const noDeleteLinkClicked = () => {
    setIsDeleteLinkClicked(false);
  }

  const handleDeleteLink = (id) => {
    const config = {
      url: `/myreadingnotesurls/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => {
      setListLinkData(listLinkData.filter(listLinkData => listLinkData._id !== id));
      setIsDeleteLinkClicked(false);
    }).catch(error => {
      console.error('Failed to delete the record:', error);
    });
  }

  const handleImageClick = () => {
    setIsOverlayOpen(true);
};

const handleCloseOverlay = () => {
    setIsOverlayOpen(false);
};


  return (
    <div
      className="readbook-container my-2 mx-auto max-w-[750px] py-4 bg-white text-black fixed-height-container"
      style={{ height: "100vh", overflow: "auto" }}
      {...swipeHandlers}
    >
        {loading ? (
          <div className="spinner-container">
            <div className="spinner">
              <FontAwesomeIcon icon={faSpinner} spin />
            </div>
          </div>
        ) : (
          <>
            <div
              className="fixed-height-container mt-2 mb-2"
              style={{
                flex: 1,
                overflowY: "auto",
                maxWidth: "100%",
                maxHeight: "100vh",
              }}
            >
              <div className="flex justify-between items-center mt-2 mb-2 bg-cyan-900 text-white mr-1 ml-1">
                <div className="text-wrap" style={{ width: "90%", maxHeight: "80px", overflow: "hidden" }}>
                  <h3 className="mt-1 mx-2 max-w-[750px] bg-cyan-900 text-white book-title ">
                    <i className="fa fa-book-open text-white" aria-hidden="true" ></i>
                    <span className="text-white ml-2 text-wrap">{bookTitle}</span>                  
                  </h3>
                  <h3 className="book-timer ml-2">{elapsedTime} seconds</h3>
                </div>
                <div style={{ width: "10%", maxHeight: "40px", overflow: "hidden" }}>
                  <button className="mx-1  bg-cyan-900" onClick={handleClose}>
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
                <div className="ml-1 mr-1 flex justify-between bg-black">
                  <button
                    className="ml-1 mt-2 max-w-8 max-h-10 bg-orange-600 text-white"
                    onClick={toggleSpeech}
                  >
                    {isSpeaking ? (
                      <FontAwesomeIcon icon={faStop} />
                    ) : (
                      <FontAwesomeIcon icon={faPlay} />
                    )}
                  </button>
                  {showEmoji && (
                    <button
                      onClick={() => setShowEmoji(false)}  
                      className="ml-1 mt-2 max-w-8 max-h-10 bg-transparent text-white" 
                    >
                      <span className="text-3xl">
                        {currentEmoji}  
                      </span>
                    </button>
                  )}
                  <button
                    className="ml-1 mt-2 max-w-8 max-h-10 bg-green-800 text-white"
                    onClick={toggleMusic}
                    disabled={hasMusic === 0}
                  >
                    {isListening ? (
                      <FontAwesomeIcon icon={faMusic} />
                    ) : (
                      <FontAwesomeIcon icon={faMusic} />
                    )}
                  </button>
                  { isChildren === 0 && (
                  <button
                    className="ml-1 mt-2 max-w-8 max-h-10 bg-purple-800 text-white"
                    onClick={readComment}
                  >
                    <FontAwesomeIcon icon={faCommenting} />
                  </button>
                  )}
                  <button
                    className="ml-1 mt-2 max-w-8 max-h-10 bg-purple-800 text-white"
                    onClick={bookLinks}
                  >
                    <FontAwesomeIcon icon={faLink} />
                  </button>
                  <button
                    className="ml-1 mt-2 max-w-8 max-h-10"
                    onClick={settings}
                  >
                    <FontAwesomeIcon icon={faGears} />
                  </button>
                  <button
                    title="Prev"
                    className="ml-1 mt-2 max-w-8 max-h-10 bg-cyan-800 text-white"
                    onClick={handlePrevPage}
                    disabled={currentPageNumber === 1}
                  >
                    <i className="fa fa-angle-left" aria-hidden="true"></i>
                  </button>
                  <select
                    className="ml-1 mt-3 max-w-15 max-h-10 bg-cyan-800 text-white border-2 border-cyan-900"
                    value={currentPageNumber}
                    onChange={handlePageChange} 
                  >
                    {[...Array(pageCount).keys()].map((page) => (
                      <option
                        className="text-white"
                        key={page + 1}
                        value={page + 1}
                      >
                        {page + 1}
                      </option>
                    ))}
                  </select>
                  <button
                    title="Next"
                    className="ml-1 mr-1 mt-2 max-w-8 max-h-10 bg-cyan-800 text-white"
                    onClick={handleNextPage}
                    disabled={currentPageNumber === pageCount}
                  >
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </div>
              <div>
            </div>
            <div
              className="ml-2 mr-2 flex items-start"
              style={{ minHeight: "100%", position: 'relative', top: 0, left: 0, right: 0 }}
              dangerouslySetInnerHTML={{ __html: pageContent }}
              {...swipeHandlers}
            />
          </div>
          {settingsClicked && (
            <>
              <div
                className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                style={{ zIndex: 1000 }}
              >
                <div className="w-full max-h-full overflow-y-auto bg-blue-200 text-black border-b border-b-gray-300 p-4 rounded-md">
                  <div>
                    <h1 className="text-xl flex justify-center text-white bg-green-500">Think5Whys Read Book Preferences</h1>
                  </div>
                  <div className="flex flex-col checkbox-group mb-4">
                   <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show View Notes / Comments Icon
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show Add Comment Icons
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show Notes External Link Icon
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Enable Flyers On The Wall Can Comment
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show Background Music Icon
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show Previous Button
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show Next Button
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show Page Selection Dropdown
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show Image Uploads In Add Notes
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Show Video Uploads In Add Notes
                    </label>
                    <label className="flex items-center mb-2 text-black">
                      <input type="checkbox" className="mr-4" />
                      Enable Personal Notes TTS
                    </label>
                    <label className="flex items-center mb-2 text-black">
                    <input
                      type="checkbox"
                      className="mr-4"
                      checked={isContinuousAutoPageReadChecked}
                      onChange={handleContinuousAutoPageReadChange}
                    />
                    Enable Continuous Auto Page Read
                    </label>
                    {isContinuousAutoPageReadChecked && (
                      <div className="mt-2 ml-6 text-black flex flex-col">
                        <label className="mr-2 text-black">From Page Number:</label>
                        <input
                          type="number"
                          min="1"
                          max={numberOfPages}
                          value={fromPageNumber}
                          onChange={handleFromPageNumberChange}
                          className="border rounded p-1 w-16 mr-4"
                        />
                        <label className="mr-2 text-black">To Page Number:</label>
                        <input
                          type="number"
                          min="1"
                          max={numberOfPages}
                          value={toPageNumber}
                          onChange={handleToPageNumberChange}
                          className="border rounded p-1 w-16"
                        />
                        <p className="text-xs text-red-600 mt-1">
                          (Max 5 pages at a time)
                        </p>
                      </div>
                    )}
                  </div>
                  <div>
                    <div className="settings-section mt-4">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={isHandWrittenTextInputEnabled}
                          onChange={(e) => setIsHandWrittenTextInputEnabled(e.target.checked)}
                          className="mr-4"
                        />
                        Enable Touchscreen Handwritten Text Input
                      </label>
                    </div>

                    <div className="settings-section mt-4">
                      <label className="flex items-center">
                        <input
                          type="checkbox"
                          checked={isHandWrittenFormulaInputEnabled}
                          onChange={(e) => setIsHandWrittenFormulaInputEnabled(e.target.checked)}
                          className="mr-4"
                        />
                        Enable Touchscreen Handwritten Formula Input
                      </label>
                    </div>
                  </div>

                  {/* Radio Button Group - Page Content TTS & Default Content TTS */}
                  <div className="radio-group mb-4 flex flex-row">
                    <label className="flex items-center mb-2 text-black">
                      <input type="radio" name="contentTTS" value="Page Content TTS" className="mr-4" />
                      Page Content TTS
                    </label>
                    <label className="ml-8 flex items-center mb-2 text-black">
                      <input type="radio" name="contentTTS" value="Default Content TTS" className="mr-4" />
                      Default Content TTS
                    </label>
                  </div>
                  
                  {/* Radio Button Group - Default Transcription (Complementary) & AI Transcription (Incurs Additional Cost) */}
                  <div className="radio-group mb-4 flex flex-row">
                    <label className="flex items-center mb-2 text-black">
                      <input type="radio" name="sttDefault" value="Default Voice Input" className="mr-4" />
                      Default Voice Input (Complementary)
                    </label>
                    <label className="ml-8 flex items-center mb-2 text-black">
                      <input type="radio" name="sttDefault" value="AI Voice Input" className="mr-4" />
                      AI Voice Input (Incurs Additional Cost)
                    </label>
                  </div>

                  {/* Select Output Language */}
                  <select
                    className="mt-4 w-full"
                    onChange={handleLanguageChange}
                    style={{
                      padding: "5px",
                      marginRight: "5px",
                      border: "1px solid #ccc",
                    }}
                  >
                    <option value="">Select Output Language</option>
                    {languageOptions.map((lang) => (
                      <option key={lang.code} value={lang.code}>
                        {lang.name}
                      </option>
                    ))}
                  </select>

                  {/* Sliders */}
                  <div className="slider-container mt-4">
                    <div className="slider-item mb-4">
                      <p>Speech Rate: {rate.toFixed(1)}</p>
                      <input
                        type="range"
                        min="0"
                        max="2"
                        step="0.1"
                        value={rate}
                        onChange={handleRateChange}
                        className="slider"
                      />
                    </div>
                    <div className="slider-item mb-4">
                      <p>Speech Volume: {volume.toFixed(1)}</p>
                      <input
                        type="range"
                        min="0"
                        max="1"
                        step="0.1"
                        value={volume}
                        onChange={handleVolumeChange}
                        className="slider"
                      />
                    </div>
                    <div className="slider-item mb-4">
                      <p>Speech Pitch: {pitch.toFixed(1)}</p>
                      <input
                        type="range"
                        min="0"
                        max="2"
                        step="0.1"
                        value={pitch}
                        onChange={handlePitchChange}
                        className="slider"
                      />
                    </div>
                  </div>

                  {/* AI Speech to Text */}
                  <div className="settings-section mt-4">
                    <h3 className="text-blue-800">AI Text To Speech</h3>
                    <div className="mt-2 flex flex-col">
                      <label htmlFor="amazonPolly" className="ml-2">
                        <input type="radio" id="amazonPolly" name="aiSpeechToText" value="Amazon Polly" onChange={handleChange} className="ml-4" />
                        Amazon Transcribe
                      </label>
                      <label htmlFor="ibmWatson" className="ml-2">
                        <input type="radio" id="ibmWatson" name="aiSpeechToText" value="IBM Watson" onChange={handleChange} className="ml-4" />
                        IBM Watson
                      </label>
                      <label htmlFor="google" className="ml-2">
                        <input type="radio" id="google" name="aiSpeechToText" value="Google" onChange={handleChange} className="ml-4" />
                        Google
                      </label>

                      <label htmlFor="google" className="ml-2">
                        <input type="radio" id="microsoft" name="aiSpeechToText" value="microsoft" onChange={handleChange} className="ml-4" />
                        Microsoft
                      </label>      

                      <label htmlFor="google" className="ml-2">
                        <input type="radio" id="deepgram" name="aiSpeechToText" value="deepgram" onChange={handleChange} className="ml-4" />
                        Deepgram
                      </label> 

                      <label htmlFor="google" className="ml-2">
                        <input type="radio" id="revAI" name="aiSpeechToText" value="revAI" onChange={handleChange} className="ml-4" />
                        Rev.ai
                      </label>

                      <label htmlFor="google" className="ml-2">
                        <input type="radio" id="speechmatics" name="aiSpeechToText" value="speechmatics" onChange={handleChange} className="ml-4" />
                        Speechmatics
                      </label>      

                      <label htmlFor="google" className="ml-2">
                        <input type="radio" id="assemblyAI" name="aiSpeechToText" value="assemblyAI" onChange={handleChange} className="ml-4" />
                        AssemblyAI
                      </label>                       

                    </div>
                  </div>

                  <div className="settings-section mt-4 flex flex-col">
                    <h3>Neural Voice Profile Preference</h3>
                    <select
                      className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                      value={selectedNeuralVoice}
                      onChange={(e) => setSelectedNeuralVoice(e.target.value)}
                    >
                      <option value="">Select Neural Voice</option>
                      <option value="neural-male">Neural Male</option>
                      <option value="neural-female">Neural Female</option>
                      <option value="neural-child">Neural Child</option>
                    </select>
                  {/* </div>

                  <div className="settings-section mt-4"> */}
                    <h3>Standard Voice Profile Preference</h3>
                    <select
                      className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                      value={selectedStandardVoice}
                      onChange={(e) => setSelectedStandardVoice(e.target.value)}
                    >
                      <option value="">Select Standard Voice</option>
                      <option value="tandard-male">Standard Male</option>
                      <option value="standard-female">Standard Female</option>
                    </select>
                  {/* </div>

                  <div className="settings-section mt-4"> */}
                    <h3>Expressive Voice Profile Preference</h3>
                    <select
                      className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                      value={selectedExpressiveVoice}
                      onChange={(e) => setSelectedExpressiveVoice(e.target.value)}
                    >
                      <option value="">Select Expressive Voice</option>
                      <option value="joyful">Joyful</option>
                      <option value="sad">Sad</option>
                    </select>
                  {/* </div>

                  <div className="settings-section mt-4"> */}
                    <h3>Regional Accent Preference</h3>
                    <select
                      className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                      value={selectedAccent}
                      onChange={(e) => setSelectedAccent(e.target.value)}
                    >
                      <option value="">Select Regional Accent</option>
                      <option value="uk-male">British Male</option>
                      <option value="uk-female">British Female</option>
                      <option value="us-male">American Male</option>
                      <option value="us-female">American Female</option>
                      <option value="au-male">Australian Male</option>
                      <option value="au-female">Australian Female</option>
                      <option value="ca-male">Canadian Male</option>
                      <option value="ca-female">Canadian Female</option>
                      <option value="in-male">Indian Male</option>
                      <option value="in-female">Indian Female</option>
                      <option value="za-male">South African Male</option> 
                      <option value="za-female">South African Female</option> 
                    </select>
                  {/* </div>

                  <div className="settings-section mt-4"> */}
                    <h3>Character Voice Profile Preference</h3>
                    <select
                      className="mt-2 p-2 border border-gray-300 rounded-md h-10"
                      value={selectedCharacterVoice}
                      onChange={(e) => setSelectedCharacterVoice(e.target.value)}
                    >
                      <option value="">Select Character Voice</option>
                      <option value="cartoon">Cartoon</option>
                      <option value="narrator">Narrator</option>
                    </select>
                  {/* </div>
                  <div className="settings-section mt-4"> */}
                  </div>

                  {/* Radio Button Group - Default STT (Complementary) & AI STT (Incurs Additional Cost) */}
                  <div className="settings-section mt-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={isVoiceNotesEnabled}
                        onChange={(e) => setIsVoiceNotesEnabled(e.target.checked)}
                        className="mr-4"
                      />
                      Enable Voice Input (STT - Speech To Text) in Notes
                    </label>
                  </div>

                  {/* Radio Button Group - Default STT (Complementary) & AI STT (Incurs Additional Cost) */}
                  { isVoiceNotesEnabled && (
                    <>
                    <div className="radio-group mb-4 flex flex-row">
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="sttChoice" value="Default STT" className="mr-4" />
                        Default STT - Web Speech (Complementary)
                      </label>
                      <label className="ml-8 flex items-center mb-2 text-black">
                        <input type="radio" name="sttChoice" value="AI STT" className="mr-4" />
                        AI STT (Incurs Additional Cost)
                      </label>
                    </div>

                    {/* AI Voice to Text */}
                    {/* {readSettings.sttChoice === 'AI STT' && ( */}
                      <div className="settings-section mt-4">
                        <h3 className="text-blue-800">AI Voice To Text</h3>
                        <div className="mt-2 flex flex-col">
                          <label htmlFor="voskSTT" className="ml-2">
                            <input type="radio" id="voskSTT" name="aistt" value="voskSTT" onChange={handleChange} className="ml-4" />
                            Vosk (AI)
                          </label>
                          <label htmlFor="deepspeechSTT" className="ml-2">
                            <input type="radio" id="deepspeechSTT" name="aistt" value="deepspeechSTT" onChange={handleChange} className="ml-4" />
                            DeepSpeech (AI)
                          </label>

                          <label htmlFor="whisperSTT" className="ml-2">
                            <input type="radio" id="whisperSTT" name="aistt" value="whisperSTT" onChange={handleChange} className="ml-4" />
                            OpenAI Whisper
                          </label>      

                          <label htmlFor="googleSTT" className="ml-2">
                            <input type="radio" id="googleSTT" name="aistt" value="googleSTT" onChange={handleChange} className="ml-4" />
                            Google
                          </label>            
                        </div>
                      </div>
                    {/* )} */}
                    </>
                  )}

                  {/* Radio Button Group - Think5Whys Smart Speaker */}
                  <div className="settings-section mt-4">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={isSmartSpeakerEnabled}
                        onChange={(e) => setIsSmartSpeakerEnabled(e.target.checked)}
                        className="mr-4"
                      />
                      Enable Thinky - The Think5Whys Smart Speaker
                    </label>
                  </div>

                  {/* Radio Button Group - Think5Whys Smart Speaker  */}
                  { isSmartSpeakerEnabled && (
                    <>
                    <div className="settings-section mt-4">
                      <h3>Speaker</h3>
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="ssChoice" value="Guddu" className="mr-4" />
                        Guddu Uncle
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="ssChoice" value="Kalam" className="mr-4" />
                        Kalam Uncle
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="ssChoice" value="Lobo" className="mr-4" />
                        Lobo Uncle
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="ssChoice" value="Gurpreet" className="mr-4" />
                        Gurpreet Uncle
                      </label>
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="ssChoice" value="Aunty" className="mr-4" />
                        Babita Aunty
                      </label>     
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="ssChoice" value="Munni" className="mr-4" />
                        Munni
                      </label> 
                      <label className="flex items-center mb-2 text-black">
                        <input type="radio" name="ssChoice" value="Munna" className="mr-4" />
                        Munna
                      </label>                                        
                    </div>
                    </>
                  )}

                  {/* Cloud Storage */}
                  <div className="settings-section mt-4">
                    <h3>Cloud Storage</h3>
                    <div className="text-black mt-2 flex flex-col">
                      <label htmlFor="personalCloud" className="ml-2">
                        <input type="radio" id="personalCloud" name="cloudStorage" value="Personal Cloud" onChange={handleChange} className="ml-4" />
                        Personal Cloud
                      </label>
                      {readSettings.cloudStorage === 'Personal Cloud' && (
                        <div className="sub-section text-black mt-2 flex flex-col">
                          <label htmlFor="googleDrive" className="ml-2">
                            <input type="radio" id="googleDrive" name="personalCloud" value="Google Drive" onChange={handleChange} className="ml-4" />
                            Google Drive
                          </label>

                          <label htmlFor="oneDrive" className="ml-2">
                            <input type="radio" id="oneDrive" name="personalCloud" value="OneDrive" onChange={handleChange} className="ml-4" />
                            OneDrive
                          </label>

                          <label htmlFor="dropBox" className="ml-2">
                            <input type="radio" id="dropBox" name="personalCloud" value="DropBox" onChange={handleChange} className="ml-4" />
                            DropBox
                          </label>
                        </div>
                      )}
                      <label htmlFor="think5WhysCloud" className="ml-2">
                        <input type="radio" id="think5WhysCloud" name="cloudStorage" value="Think5Whys Cloud" onChange={handleChange} className="ml-4" />
                        Think5Whys Cloud
                      </label>

                      <label htmlFor="privateCloud" className="ml-2">
                        <input type="radio" id="privateCloud" name="cloudStorage" value="Private Cloud" onChange={handleChange} className="ml-4" />
                        Private Cloud
                      </label>

                      <label htmlFor="governmentCloud" className="ml-2">
                        <input type="radio" id="governmentCloud" name="cloudStorage" value="Government Cloud" onChange={handleChange} className="ml-4" />
                        Government Cloud
                      </label>
                    </div>
                  </div>

                  <div className="flex flex-row mt-4 mb-4 justify-center">
                    <button
                      className="bg-purple-700 text-white py-2 px-4 rounded"
                      onClick={() => handleSaveSettings()}
                    >
                      Save Preferences
                    </button>
                    <button
                      className="bg-purple-700 text-white py-2 px-4 rounded ml-4"
                      onClick={handleSettingsClose}
                    >
                      Close
                    </button>
                  </div>
                  {errors && <p className="text-red-600">{errors}</p>}
                  {postedCommentMsg && <p>{postedCommentMsg}</p>}
                </div>
              </div>
            </>
          )}
          {readCommentClicked && (
            <div
                className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center text-sm"
                style={{ zIndex: 1000 }}
              >
                <div className="w-full h-full overflow-y-auto bg-blue-200 text-black border-b border-b-gray-300 p-4 rounded-md">
                  <div className="flex justify-center items-center text-blue-800 text-lg border-b">
                    <p>
                      {sortedCommentData.length}  Comments/Notes on  
                      Page# {currentPageNumber} for the book {bookTitle}</p>
                  </div>
                  <div className="flex flex-row justify-center text-blue-800 text-sm border-b">
                    <button
                      className="ml-2 mt-2 w-20 max-h-10 bg-purple-800 text-white"
                      onClick={handleViewComment}
                    >
                      <FontAwesomeIcon icon={faComments} /> List
                    </button>
                    <button
                      className="ml-2 mt-2 w-40 max-h-10 bg-purple-800 text-white"
                      onClick={postComment}
                    >
                      <FontAwesomeIcon icon={faEdit} /> Add New 
                    </button>
                    <button
                      className="ml-2 mt-2 w-20 max-h-10 bg-purple-800 text-white"
                      onClick={handlePostClose}
                    >
                      <FontAwesomeIcon icon={faTimes} /> Close
                    </button>
                  </div>
                  {viewComment && (
                    <>
                      {sortedCommentData.length > 0 ? (
                        sortedCommentData.map((commentItem, commentIndex) => (
                          <div
                            key={commentIndex}
                            className="mb-6 p-6 bg-white shadow-xl rounded-lg border border-gray-200 hover:shadow-2xl transition-shadow duration-300"
                          >
                            <h4 className="text-2xl font-bold text-gray-900 mb-2">
                              {commentItem.notesType}
                            </h4>
                            <p className="text-lg font-semibold text-blue-700 mb-2">
                              {commentItem.notesTitle}
                            </p>
                            <p className="text-base text-gray-700 mb-4">
                              <strong>Details:</strong>
                              <br />
                              {commentItem.notesText}
                            </p>
                            <div className="flex justify-between items-center">
                              <p className="text-sm text-gray-600">
                                <strong>Is Important: </strong>
                                {commentItem.isImportant ? (
                                  <span className="text-red-600 font-semibold">Yes</span>
                                ) : (
                                  "No"
                                )}
                              </p>
                              <p className="text-sm text-gray-600">
                                <strong>By: </strong>
                                {commentItem.notesBy}
                              </p>
                            </div>
                            <p className="text-right text-sm text-gray-500 mt-4">
                              <strong>Date: </strong>
                              {formatDateTime(commentItem.dateCreated)}
                            </p>
                            <div className="flex justify-end items-center mt-4">
                              <select
                                value={selectedLangCode}
                                onChange={(e) => setSelectedLangCode(e.target.value)}
                                className="ml-4 p-2 h-8 border border-gray-300 rounded"
                              >
                                {languageOptions.map((option) => (
                                  <option key={option.code} value={option.code}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                              <button
                                className="ml-1 mt-2  mr-4 max-w-8 max-h-8 bg-green-600 text-white"
                                onClick={() => listenNotesClicked(commentItem.notesText)}
                              >
                                {isNotesSpeaking ? (
                                  <FontAwesomeIcon icon={faStop} />
                                ) : (
                                  <FontAwesomeIcon icon={faPlay} />
                                )}
                            </button>
                            <Tooltip text="Delete this record" position="top">
                              <span
                                className="text-red-500 cursor-pointer hover:text-red-700 transition-colors  max-w-8 max-h-8"
                                onClick={() => deleteCommentClicked()}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </span>
                            </Tooltip>
                          </div>

                            {isDeleteCommentClicked && (
                              <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                                <div className="w-96 bg-white rounded-lg p-6 shadow-xl text-center">
                                  <p className="text-lg font-semibold mb-4 text-gray-800">
                                    Are you sure you want to delete this record?
                                  </p>
                                  <div className="flex justify-center space-x-4">
                                    <button
                                      className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 transition-colors"
                                      onClick={() => handleDeleteComment(commentItem._id)}
                                    >
                                      Confirm Delete
                                    </button>
                                    <button
                                      className="bg-gray-300 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-400 transition-colors"
                                      onClick={() => noDeleteCommentClicked()}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                            

                          </div>
                        ))
                      ) : (
                        <div className="mt-20 mb-20 flex justify-center text-center">
                          <p className="text-lg font-medium text-orange-500">
                            There are no Notes / Comments / Remarks for this Page!
                          </p>
                        </div>
                      )}
                    </>
                  )}
                  {postCommentClicked && (
                    <>
                      <div className="w-full flex flex-col bg-white shadow-md rounded-lg p-4 border border-gray-300">
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Add a New Comment</h3>
                        <div className="mb-4">
                          <label className="text-sm text-gray-700 ml-1">Type*: </label>
                          <select
                            name="notesType"
                            id="notesType"
                            value={notesType}
                            onChange={(e) => setNotesType(e.target.value)}
                            className="w-full border rounded-md p-2 h-8 text-black "
                          >
                            <option value="Quick Note">Quick Comment (Default)</option>
                            <option value="Study Notes">Study Notes</option>
                            <option value="Notes for Exam">Notes for Exam</option>
                            <option value="Page Summary">Page Summary</option>
                            <option value="Audio Notes">Audio Notes</option>
                            <option value="Formula">Formula</option>
                            <option value="Assignment">Assignment</option>
                            <option value="Project">Project</option>
                            <option value="Query">Query</option>
                            <option value="Reference">Reference</option>
                            <option value="Experience">Experience</option>
                            <option value="Index / Keywords">Index / Keywords</option>
                            <option value="Book Summary">Book Summary</option>
                            <option value="Past Questions">Past Questions</option>
                            <option value="My Question - Comprehension">My Question - Comprehension</option>
                            <option value="My Question - Fill Up The Blanks">My Question - Fill Up The Blanks</option>
                            <option value="My Question - Long Answer Type">My Question - Long Answer Type</option>
                            <option value="My Question - Matching">My Question - Matching</option>
                            <option value="My Question - MCQ">My Question - MCQ</option>
                            <option value="My Question - Non-Numericals">My Question - Non-Numericals</option>
                            <option value="My Question - Numericals">My Question - Numericals</option>
                            <option value="My Question - Short Answer Type">My Question - Short Answer Type</option>
                            <option value="My Question - True/False">My Question - True/False</option>
                            <option value="Image">Image</option>
                            <option value="Video">Video</option>
                            <option value="TODO Action Items">TODO / Kaizen Action Items</option>
                            <option value="Appreciation">Appreciation</option>
                          </select>
                        </div>
                        <div className="mb-4">
                          <label className="text-sm text-gray-700 ml-1">Title*: </label>
                          <input
                            type="text"
                            value={userCommentTitle}
                            onChange={(e) => setUserCommentTitle(e.target.value)}
                            placeholder="Input title"
                            className="w-full border rounded-md p-2 bg-gray-50"
                          />
                        </div>
                        {notesType === 'Audio Notes' && (
                          <>
                            <label htmlFor="conversationalNotes" className="text-sm text-gray-700 ml-1">
                              <input
                                type="checkbox"
                                id="showMicrophoneAlert"
                                checked={showMicrophoneAlert}
                                onChange={handleShowMicrophoneAlertCheckboxChange}
                                className="mr-2"
                              />
                              Enable Microphone 🎤
                            </label>
                            {showMicrophoneAlert && (
                              <label htmlFor="conversationalNotes" className="text-sm text-gray-700 ml-1">
                                <input
                                  type="checkbox"
                                  id="conversationalNotes"
                                  checked={isConversationalNotes}
                                  onChange={handleConversationalNotesCheckboxChange}
                                  className="mr-2"
                                />
                                Make it a Conversational Note (Powered by Think5Whys AI Partners)
                              </label>
                            )}
                          </>
                        )}
                        <div className="mb-4">
                          <label className="text-sm text-gray-700 ml-1">Notes/Comments/Remarks Details*: </label>
                          {showMicrophoneAlert ? (
                            <SpeechInputComponent
                              label="Notes Notes"
                              name="userCommentDetails"
                              value={userCommentDetails}
                              onChange={(e) => setUserCommentDetails(e.target.value)}
                              placeholder="Click Mic and Speak or Talk for Voice Input..."
                              maxLength="2000"
                              className="w-full border rounded-md p-2 bg-gray-50"
                            />
                          ) : (
                            <textarea
                              type="text"
                              name="userCommentDetails"
                              id="userCommentDetails"
                              value={userCommentDetails}
                              placeholder="Write here..."
                              onChange={(e) => setUserCommentDetails(e.target.value)}
                              maxLength="2000"
                              style={{
                                border: '1px solid #ccc',
                                padding: '2px',
                                backgroundColor: '#f0f0f0',
                                color: '#000000',
                                maxWidth: '100%',
                                height: '200px' // Set height to 200px
                              }}
                            />
                          )}
                        </div>

                        {/* Handwriting & Math OCR Section */}
                        {/* <div className="mb-4 flex flex-wrap">
                          <button className="mr-4 mb-2 w-auto bg-blue-500 text-white px-4 py-2 rounded-md" onClick={handleOpenHandwriting}>
                            Open Handwriting to Text
                          </button>
                          {isHandwritingVisible && (
                            <HandwritingToText onClose={handleCloseHandwriting} />
                          )}
                          <button className="mb-2 w-auto bg-blue-500 text-white px-4 py-2 rounded-md" onClick={handleOpenMathOCR}>
                            Open Handwritten Math Formula to Text
                          </button>
                          {isMathOCRVisible && (
                            <MathOCR onClose={handleCloseMathOCR} />
                          )}
                        </div> */}

                        {/* AI Support Section */}
                        <div className="mb-4">
                          <label className="text-sm text-gray-700 ml-1">
                            <input
                              type="checkbox"
                              checked={isCheckedAISupport}
                              onChange={(e) => setIsCheckedAISupport(!isCheckedAISupport)}
                              className="mr-2"
                            />
                            I want to take Gen AI Support for generating my AI Prompt.
                          </label>
                          {isCheckedAISupport && userCommentDetails !== '' && (
                            <div className="mt-2">
                              <AILightComponent param1={notesType} param2={' Title: ' + userCommentTitle + ' Remarks: ' + userCommentDetails} />
                            </div>
                          )}
                        </div>

                        {/* Important and Visibility Checkboxes */}
                        <div className="mb-4 flex ">
                          <label htmlFor="important" className="text-sm text-gray-700 ml-1">
                            <input
                              type="checkbox"
                              id="important"
                              checked={isImportantChecked}
                              onChange={handleImportantCheckboxChange}
                              className="mr-2"
                            />
                            Is Important
                          </label>
                          <label htmlFor="visibleToAll" className="text-sm text-gray-700 ml-1">
                            <input
                              type="checkbox"
                              id="visibleToAll"
                              checked={isVisibleToAllChecked}
                              onChange={handleVisibleToAllCheckboxChange}
                              className="mr-2"
                            />
                            Visible to All
                          </label>
                        </div>
                        <div className="mb-4">
                          {errors && !postedComment && (
                            <p className="text-red-600">{errors}</p>
                          )}
                          {postedCommentMsg && <p className="text-green-600">{postedCommentMsg}</p>}
                        </div>
                        <div className="flex justify-strat">
                        <button
                          className="bg-purple-700"
                          onClick={() =>
                            handlePostComment(
                              userCommentTitle,
                              userCommentDetails,
                              isImportantChecked,
                              isVisibleToAllChecked,
                              currentPageNumber,
                              bookTitle
                            )
                          }
                          disabled={postedComment} 
                          style={{ maxWidth: "150px" }}
                        >
                          {postedComment ? "Posted..." : "Post"}  
                        </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
          )}
          {bookLinkClicked && (
            <>
            <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center" style={{ zIndex: 1000 }}>
              <div className="w-full h-full overflow-y-auto bg-blue-200 text-black border-b border-b-gray-300 p-4 rounded-md">
                <div className="flex justify-center">
                  <p className="text-yellow-800 text-lg">External Links/URLs of the Books {bookTitle}, Page Number {currentPageNumber}</p>
                </div>
                <div className="flex justify-center mt-4">
                  <button
                    className="bg-green-700"
                    onClick={handleListLinkButtonClick}
                    style={{ width: "150px" }}
                  >
                    List
                  </button>
                  <button
                    className="bg-green-700 ml-2"
                    onClick={handleAddNewLinkButtonClick}
                    style={{ width: "150px" }}
                  >
                    Add New
                  </button>
                  <button
                    className="bg-green-700 ml-2"
                    onClick={handleCloseLinkButtonClick}
                    style={{ width: "150px" }}
                  >
                    Close
                  </button>
                </div>
                {listLink && (
                  <div className="flex flex-col justify-center p-8 bg-gray-50 min-h-screen">
                    {sortedListLinkData.length > 0 ? (
                      sortedListLinkData.map((linkItem, linkIndex) => (
                        <div key={linkIndex} className="flex flex-col items-start w-full mb-6 p-6 bg-white border border-gray-300 shadow-lg rounded-lg transition-transform transform hover:scale-105">
                          <p className="text-xl font-semibold text-gray-900 mb-2">
                            <strong>Link/Site Name:</strong> {linkIndex + 1}. {linkItem.linkName}
                          </p>
                          <p className="text-lg text-gray-800 mb-2">
                            <strong>Page/Channel Name:</strong> {linkItem.linkPageName}
                          </p>
                          <p className="text-lg text-gray-800 mb-2">
                            <strong>URL/Link Address:</strong> 
                            <a
                              href={linkItem.linkAddress}
                              className="text-blue-600 underline hover:text-blue-800"
                              onClick={(e) => {
                                e.preventDefault();
                                accessSite(linkItem.linkAddress);
                              }}
                            >
                              {linkItem.linkAddress}
                            </a>
                          </p>
                          <p className="text-lg text-gray-800">
                            <strong>Details:</strong> {linkItem.linkDetails}
                          </p>
                          <div className="flex items-center mt-4">
                            <Tooltip text="Delete this record" position="top">
                              <span className='text-red-600 cursor-pointer mr-2' onClick={() => deleteLinkClicked()}>
                                <i className="fa-solid fa-trash"></i>
                              </span>
                            </Tooltip>
                            {isDeleteLinkClicked && (
                              <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center">
                                <div className="bg-white p-6 rounded-lg shadow-lg w-80 text-center">
                                  <p className="mb-4 text-lg font-semibold text-gray-800">Are you sure you want to delete this record?</p>
                                  <div className="flex justify-center">
                                    <button
                                      className="bg-red-600 text-white py-2 px-4 rounded-lg mr-4 hover:bg-red-700 transition-colors"
                                      onClick={() => handleDeleteLink(linkItem._id)}
                                    >
                                      Confirm Delete
                                    </button>
                                    <button
                                      className="bg-gray-300 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-400 transition-colors"
                                      onClick={() => noDeleteLinkClicked()}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="mt-20 mb-20 flex justify-center text-center">
                        <p className="text-lg text-blue-600 font-medium">
                          <span className="text-orange-600">There are no Link/Page URLs for this Page!</span>
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {addNewLink && (
                  <div className="text-sm">
                    <p className="ml-4">Link/Site Name*: </p>
                    <input
                      className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                      style={{ width: "50%" }}
                      value={linkName}
                      onChange={(e) => setLinkName(e.target.value)}
                      placeholder="Input link name"
                    />
                    <p className="ml-4">Channel/Page Name*: </p>
                    <input
                      className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                      style={{ width: "50%" }}
                      value={linkPageName}
                      onChange={(e) => setLinkPageName(e.target.value)}
                      placeholder="Input Page/Channel Name"
                    />
                    <p className="ml-4">Link Title*: </p>
                    <input
                      className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                      style={{ width: "70%" }}
                      value={linkTitle}
                      onChange={(e) => setLinkTitle(e.target.value)}
                      placeholder="Input title"
                    />
                    <p className="ml-4">Link Address/URL*: </p>
                    <input
                      className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                      style={{ width: "90%" }}
                      value={linkAddress}
                      onChange={(e) => setLinkAddress(e.target.value)}
                      placeholder="Input/Copy-Paste address"
                    />
                    <p className="ml-4">
                    <label htmlFor="isvideo" className="text-sm text-black">
                      <input
                        type="checkbox"
                        id="isvideo"
                        checked={isVideoChecked}
                        onChange={handleIsVideoCheckboxChange}
                        className="mr-2"
                      />
                      Is Video*
                    </label>
                    </p>
                    <p className="mt-2 ml-4">About the Link: </p>
                    <textarea
                      className="text-black ml-4 bg-slate-100 mb-2 w-full p-2"
                      style={{ height: "200px", width: "90%" }}
                      value={linkDetails}
                      onChange={(e) => setLinkDetails(e.target.value)}
                      placeholder="Input details"
                    />

                    <div className="ml-4 mr-r mb-4 flex flex-col">
                      {errors && <p className="text-red-600">{errors}</p>}
                      {bookLinkSaved && <p>{bookLinkSavedMsg}</p>}
                      <button
                        className="bg-purple-700"
                        onClick={() =>
                          handleSaveBookLink(
                            linkName,
                            linkPageName,
                            linkTitle,
                            linkAddress,
                            isVideoChecked,
                            linkDetails,
                            currentPageNumber
                          )
                        }
                        disabled={saveBookLinkToBeDisabled && bookLinkSaved}
                        style={{ maxWidth: "150px" }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            </>
          )}
          </>
        )}
      </div>
  );
};

export default ReadMSMEYB;
